@if (!supplierId) {
  <!-- Modalità  standalone con layout completo -->
  <div class="contracts-registry-container">
    <!-- Breadcrumb -->
    <div class="mb-4">
      <p-breadcrumb
        styleClass="custom-breadcrumb"
        [model]="breadcrumbItems()"
        [home]="{ icon: 'pi pi-home', routerLink: '/', ariaLabel: 'Home' }"
      >
      </p-breadcrumb>
    </div>

    <!-- Page Header -->
    <section class="page-header" aria-labelledby="contracts-registry-heading">
      <div class="header-content">
        <div class="header-left">
          <i class="pi pi-file-edit header-icon" aria-hidden="true"></i>
          <div class="header-text">
            <h1 id="contracts-registry-heading">{{ pageTitle() }}</h1>
            <p class="subtitle">{{ pageSubtitle() }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Reusable Table Component -->
    <app-registry-table
      title="Lista Contratti"
      icon="pi-file-edit"
      [columns]="columns"
      [data]="contractsData()"
      [loading]="isLoading()"
      [showClearFiltersButton]="showClearFilters"
      [emptyStateTitle]="emptyTitle()"
      [emptyStateMessage]="emptyMessage()"
      [initialFilters]="initialFilters()"
      (onDetailClick)="onDetailClick($event)"
      (onEditClick)="onEditClick($event)"
      (onDeleteClick)="onDeleteClick($event)"
      (onClearFilters)="onClearFilters()"
    ></app-registry-table>

    <!-- Toast for notifications -->
    <p-toast role="status" aria-live="polite" aria-atomic="true" />
  </div>
} @else {
  <!-- Modalità embedded (nel dettaglio fornitore) senza header -->
  <app-registry-table
    title="Lista Contratti"
    icon="pi-file-edit"
    [columns]="columns"
    [data]="contractsData()"
    [loading]="isLoading()"
    [showClearFiltersButton]="showClearFilters"
    [emptyStateTitle]="emptyTitle()"
    [emptyStateMessage]="emptyMessage()"
    [initialFilters]="initialFilters()"
    (onDetailClick)="onDetailClick($event)"
    (onEditClick)="onEditClick($event)"
    (onDeleteClick)="onDeleteClick($event)"
    (onClearFilters)="onClearFilters()"
  ></app-registry-table>

  <!-- Toast for notifications -->
  <p-toast role="status" aria-live="polite" aria-atomic="true" />
}
